import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-report-parent',
    templateUrl: './report-parent.component.html',
    styleUrls: ['./report-parent.component.scss'],
    standalone: false
})
export class ReportParentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
